<template>
    <div>
        <div class="kgr-grid kgr-grid--gutters kgr-row">
            <div class="kgr-grid__cell">
                <div class="kgr-float kgr-float--left kgr-float--inText">
                    <div class="kgr-inputGroup">
                        <label class="kgr-inputGroup__label">{{ $t('Diagrammart') }}</label>
                        <kgr-generic-select
                            display="label"
                            :value="selectedType"
                            :options="types"
                            :no-null-option="true"
                            :inline="false"
                            @post-input="setSelectedType($event)"
                        />
                    </div>
                </div>
                <div class="kgr-float kgr-float--left kgr-float--inText">
                    <div class="kgr-inputGroup">
                        <label class="kgr-inputGroup__label">{{ $t('Terminals') }}</label>
                        <kgr-multi-select
                            v-model="selectedTerminals"
                            :options="filteredTerminals"
                            :inline="false"
                            @post-input="setPreFilter()"
                        />
                    </div>
                </div>
                <div class="kgr-float kgr-float--left kgr-float--inText">
                    <div class="kgr-inputGroup">
                        <label class="kgr-inputGroup__label">{{ $t('Startdatum') }}</label>
                        <kgr-date-picker
                            v-model="formattedStartDate"
                        />
                    </div>
                </div>
                <div class="kgr-float kgr-float--left kgr-float--inText">
                    <div class="kgr-inputGroup">
                        <label class="kgr-inputGroup__label">{{ $t('Enddatum') }}</label>
                        <kgr-date-picker
                            v-model="formattedEndDate"
                        />
                    </div>
                </div>
            </div>
        </div>
        <kgr-loading v-if="loading" />
        <div v-else>
            <kgr-empty-data
                v-if="data === undefined || data === null || data.length === 0"
                :value="$t('Keine Daten vorhanden')"
            />
            <highcharts
                v-else
                :options="chartOptions"
            />
        </div>
    </div>
</template>

<script>
import DatePicker from '../../components/common/form/picker/DatePicker';
import EmptyData from '../../components/common/EmptyData';
import GenericSelect from '../../components/common/form/select/GenericSelect';
import Loading from '../../components/common/Loading';
import MultiSelect from '../../components/common/form/select/MultiSelect';
import PhysicalAccessLogRepository from '../../js/repository/PhysicalAccessLogRepository';
import PhysicalAccessTerminalRepository from '../../js/repository/PhysicalAccessTerminalRepository';
import moment from 'moment';

export default {
    name: 'Statistics',
    components: {
        'kgr-multi-select': MultiSelect,
        'kgr-generic-select': GenericSelect,
        'kgr-date-picker': DatePicker,
        'kgr-empty-data': EmptyData,
        'kgr-loading': Loading,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            selectedTerminals: [],
            terminals: [],
            types: [
                {
                    label: this.$t('physicalAccess.stats.type.H'),
                    value: 'H',
                },
                {
                    label: this.$t('physicalAccess.stats.type.w'),
                    value: 'w',
                },
                {
                    label: this.$t('physicalAccess.stats.type.e'),
                    value: 'e',
                },
            ],
            selectedType: {},
            dateTimeRange: {},
            preFilter: {
                terminals: [],
                inDateTimeRange: {},
                type: null,
            },
            dayHours: [
                '0',
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21',
                '22',
                '23',
            ],
            weekDays: [
                this.$t('weekly_1'),
                this.$t('weekly_2'),
                this.$t('weekly_3'),
                this.$t('weekly_4'),
                this.$t('weekly_5'),
                this.$t('weekly_6'),
                this.$t('weekly_7'),
            ],
            monthlyDays: [
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21',
                '22',
                '23',
                '24',
                '25',
                '26',
                '27',
                '28',
                '29',
                '30',
                '31',
            ],
            data: null,
            chartOptions: {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'column',
                    width: 1000
                },
                yAxis: {
                    title: {
                        text: this.$t('Anzahl'),
                    },
                    min: 0,
                },
                xAxis: {
                    gridLineWidth: 1,
                    plotBands: [{
                        color: 'rgba(0, 0, 0, 0.1)',
                    }],
                    title: {
                        text: '',
                    },
                    labels: {
                        step: 1,
                        format: '{text}',
                        useHTML: true,
                        style: {
                            fontWeight: 'var(--kgr-font-weight-normal)'
                        }
                    },
                    type: 'category',
                    categories: [],
                    min: 0,
                },
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '',
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'var(--kgr-font-weight-normal)'
                            }
                        },
                        enableMouseTracking: false,
                    },
                    series: {
                        label: {
                            connectorAllowed: false,
                            style: {
                                fontWeight: 'var(--kgr-font-weight-normal)'
                            }
                        },
                    }
                },
                series: [{
                    name: this.$t('Anzahl'),
                    data: []
                }],
                credits: {
                    enabled: false
                },
                legend: {
                    enabled: false,
                    align: 'right',
                    layout: 'vertical',
                    verticalAlign: 'middle',
                    itemStyle: {
                        fontWeight: 'var(--kgr-font-weight-bold)',
                    }
                },
            }
        }
    },
    computed: {
        filteredTerminals() {
            return this.terminals.filter(terminal => {
                return this.selectedTerminals.find(selectedTerminal => terminal.value === selectedTerminal.value) === undefined
            });
        },
        formattedStartDate: {
            get() {
                return this.dateTimeRange.start.format('DD.MM.YYYY');
            },
            set(newDate) {
                newDate = moment(newDate, 'DD.MM.YYYY');
                this.dateTimeRange.start = moment(this.dateTimeRange.start).set('date', newDate.date()).set('month', newDate.month()).set('year', newDate.year());
                this.setPreFilter();
            }
        },
        formattedEndDate: {
            get() {
                return this.dateTimeRange.end.format('DD.MM.YYYY');
            },
            set(newDate) {
                newDate = moment(newDate, 'DD.MM.YYYY');
                this.dateTimeRange.end = moment(this.dateTimeRange.end).set('date', newDate.date()).set('month', newDate.month()).set('year', newDate.year());
                this.setPreFilter();
            }
        },
    },
    created() {
        this.dateTimeRange = {
            start: moment().startOf('week').startOf('date'),
            end: moment().endOf('date'),
        };
        this.setSelectedType({ label: this.$t('physicalAccess.stats.type.H'), value: 'H' });
        PhysicalAccessTerminalRepository
            .findByClub(this.clubId)
            .then(terminals => terminals.forEach(terminal => this.terminals.push({'label': terminal.name, 'value': terminal.id})));
    },
    methods: {
        load(filters) {
            if (!this.data) {
                this.loading = true;
            }
            PhysicalAccessLogRepository
                .findByClubForStats(this.clubId, filters)
                .then(response => {
                    if( this.selectedType.value === 'w') {
                        response.push(response.shift());
                    }
                    if (this.selectedType.value === 'e') {
                        this.chartOptions.series = response;
                    } else {
                        this.chartOptions.series = [{
                            name: this.$t('Anzahl'),
                            data: []
                        }];
                        this.chartOptions.series[0].data = response;
                    }
                    this.data = response;
                    this.loading = false;
                });
        },
        setSelectedType(type) {
            this.loading = true;
            this.selectedType = type;

            this.chartOptions.xAxis.title.text = this.$t('physicalAccess.stats.type.' + this.selectedType.value);
            if (this.selectedType.value === 'H') {
                this.chartOptions.xAxis.labels.format = '{value}';
                this.chartOptions.xAxis.categories = this.dayHours;
                this.chartOptions.xAxis.max = this.dayHours.length - 1;
                this.chartOptions.tooltip.pointFormat = '<span class="kgr-text--bold">{point.name}:00</span>: {point.y}';
                this.chartOptions.legend.enabled = false;
            } else if(this.selectedType.value === 'w') {
                this.chartOptions.xAxis.labels.format = '{value}';
                this.chartOptions.xAxis.categories = this.weekDays;
                this.chartOptions.xAxis.max = this.weekDays.length - 1;
                this.chartOptions.tooltip.pointFormat = '<span class="kgr-text--bold">{point.name}</span>: {point.y}';
                this.chartOptions.legend.enabled = false;
            } else {
                this.chartOptions.xAxis.labels.format = '{value}.';
                this.chartOptions.tooltip.pointFormat = '<span class="kgr-text--bold">{point.name}.</span>: {point.y}';
                this.chartOptions.xAxis.categories = this.monthlyDays;
                this.chartOptions.xAxis.max = this.monthlyDays.length - 1;
                this.chartOptions.legend.enabled = true;
            }

            this.setPreFilter();
        },
        setPreFilter() {
            this.preFilter.terminals = [];
            this.preFilter.inDateTimeRange = {};
            this.preFilter.type = null;

            this.selectedTerminals.forEach(terminal => this.preFilter.terminals.push(terminal.label));
            this.preFilter.inDateTimeRange.start = this.dateTimeRange.start.format('YYYY-MM-DD HH:mm:ss');
            this.preFilter.inDateTimeRange.end = this.dateTimeRange.end.format('YYYY-MM-DD HH:mm:ss');
            this.preFilter.type = this.selectedType.value;

            this.load(this.preFilter);
        },
    }
}
</script>

<style scoped>

</style>
